<div class="search-result" [ngClass]="{'search-result__type_l' : type === 'l', 'search-result__type_s' : type === 's'}" (click)="onClick()">

  <div *ngIf="config && data" class="search-result__content entity-card">
    <div class="entity-card__header">

      <!-- Ikona -->
      <div class="entity-card__icon">
        <i [ngClass]="config.icon"></i>
      </div>

      <div class="entity-card__info">

        <!-- Název -->
        <div class="entity-card__name">
          <ng-container *ngIf="config.nameLink; else plainName">
            <a [uiSref]="config.nameLink.state"
               [uiParams]="resolveParams(config.nameLink.params)"
               class="entity-card__link" (click)="$event" target="_blank"
               [gmtHighlight]="result.highlight">{{ resolveValue(config.nameField) }}</a>
          </ng-container>
          <ng-template #plainName>
            <ng-container *ngIf="resolveValue(config.nameField); else nameFallback">
              <span [gmtHighlight]="result.highlight">{{ resolveValue(config.nameField) }}</span>
            </ng-container>
            <ng-template #nameFallback>
              <i *ngIf="config.nameFallback">{{ config.nameFallback }}</i>
            </ng-template>
          </ng-template>
        </div>

        <!-- Detail sekce (iterace přes config.sections) -->
        <ng-container *ngFor="let section of config.sections">
          <div *ngIf="checkCondition(section.condition)" class="entity-card__details">
            <ng-container *ngFor="let field of section.fields">
              <span *ngIf="isFieldVisible(field)" class="entity-card__detail-item">
                <span class="entity-card__detail-label">{{ field.label }}:</span>
                <ng-container *ngIf="field.highlight !== false; else noHl">
                  <span [gmtHighlight]="result.highlight">{{ resolveValue(field.field) }}</span>
                </ng-container>
                <ng-template #noHl>
                  {{ resolveValue(field.field) }}{{ field.suffix }}
                </ng-template>
              </span>
            </ng-container>
          </div>
        </ng-container>

        <!-- Odkaz na akci: single (data.projectKey) -->
        <div *ngIf="config.projectLink && config.projectLink.mode === 'single' && data.projectKey" class="entity-card__details">
          <span class="entity-card__detail-item">
            <span class="entity-card__detail-label">Název akce:</span>
            <a [uiSref]="config.projectLink.state"
               [uiParams]="resolveParams(config.projectLink.params)"
               class="entity-card__link" (click)="$event" target="_blank"
               [gmtHighlight]="result.highlight">{{ data.projectName }}</a>
          </span>
        </div>

        <!-- Odkaz na akci: array – jeden projekt -->
        <div *ngIf="config.projectLink && config.projectLink.mode === 'array' && data.projects && data.projects.length === 1" class="entity-card__details">
          <span class="entity-card__detail-item">
            <span class="entity-card__detail-label">Název akce:</span>
            <a [uiSref]="config.projectLink.state"
               [uiParams]="resolveParams(config.projectLink.params, data.projects[0])"
               class="entity-card__link" (click)="$event" target="_blank"
               [gmtHighlight]="result.highlight">{{ data.projects[0].projectName }}</a>
          </span>
        </div>

        <!-- Odkaz na akci: array – více projektů -->
        <ng-container *ngIf="config.projectLink && config.projectLink.mode === 'array' && data.projects && data.projects.length > 1">
          <div class="entity-card__accordion">
            <gmt-labeled-block [label]="'Název akce (' + data.projects.length + ')'" [collapsed]="true">
              <perfect-scrollbar [ngStyle]="{'max-height': '120px'}" [wheelPropagation]="false">
                <ul class="entity-card__project-list">
                  <li *ngFor="let p of data.projects">
                    <a [uiSref]="config.projectLink.state"
                       [uiParams]="resolveParams(config.projectLink.params, p)"
                       class="entity-card__link" (click)="$event" target="_blank"
                       [gmtHighlight]="result.highlight">{{ p.projectName }}</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </gmt-labeled-block>
          </div>
        </ng-container>

        <!-- Odkaz na akci: conditional (komponenty – více podmíněných linků) -->
        <div *ngIf="config.projectLink && config.projectLink.mode === 'conditional' && data.projectKey" class="entity-card__details">
          <ng-container *ngIf="getActiveProjectLink() as link">
            <span class="entity-card__detail-item">
              <span class="entity-card__detail-label">Název akce:</span>
              <a [uiSref]="link.state"
                 [uiParams]="resolveParams(link.params)"
                 class="entity-card__link" (click)="$event" target="_blank"
                 [gmtHighlight]="result.highlight">{{ data.projectName }}</a>
            </span>
          </ng-container>
        </div>

        <!-- Seznam vlastníků: pipe-separated field (např. case.subjectsNames) -->
        <ng-container *ngIf="config.subjectList">
          <ng-container *ngIf="resolveSubjectList(config.subjectList.field) as names">
            <div *ngIf="names.length === 1" class="entity-card__details">
              <span class="entity-card__detail-item">
                <span class="entity-card__detail-label">{{ config.subjectList.label }}:</span>
                <span [gmtHighlight]="result.highlight">{{ names[0] }}</span>
              </span>
            </div>
            <div *ngIf="names.length > 1" class="entity-card__accordion">
              <gmt-labeled-block [label]="(config.subjectList.labelPlural || config.subjectList.label) + ' (' + names.length + ')'" [collapsed]="true">
                <perfect-scrollbar [ngStyle]="{'max-height': '120px'}" [wheelPropagation]="false">
                  <ul class="entity-card__project-list">
                    <li *ngFor="let name of names"><span [gmtHighlight]="result.highlight">{{ name }}</span></li>
                  </ul>
                </perfect-scrollbar>
              </gmt-labeled-block>
            </div>
          </ng-container>
        </ng-container>

      </div>

      <!-- Skóre / Badge -->
      <div class="entity-card__actions">
        <span *ngIf="config.showScoreValue" class="entity-card__score">Skóre: {{ result.score | number:'1.2-2' }}</span>
        <span class="entity-card__badge"
              [title]="config.showScoreValue ? '' : 'Skóre: ' + (result.score | number:'1.2-2')">{{ config.label }}</span>
      </div>

    </div>
  </div>

</div>
